<template>
  <div class="game-card">
    <component :is="image" class="game-icon" />
    <div class="game-info">
      <span class="game-name">{{ name }}</span>
      <div class="game-value">
        <span class="currency-icon">C$</span>
        <span>{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GameCard",
  props: {
    image: [String, Object],
    name: String,
    value: [Number, String],
  },
};
</script>

<style scoped>
.game-card {
  background-color: rgb(36 36 41);
  border: 2px solid rgb(38 38 43);
  border-radius: 16px;
  flex: 1;
  padding: 12px;
  width: 150px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

@media only screen and (max-width: 768px) {
  .game-card { flex: 0 0 calc(50% - 8px); }
}
@media only screen and (max-width: 480px) {
  .game-card { flex: 0 0 100%; }
}

.game-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}

.game-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.game-name {
  color: #fff;
  font-weight: 500;
  font-size: 1rem;
}

.game-value {
  background-color: rgb(15 80 70);
  color: #fff;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
}

.currency-icon {
  font-weight: 600;
  color: rgb(15 80 70);
  background-color: rgb(203 190 137);
  border-radius: 9999px;
  padding: 0 0.25rem;
}
</style>
